<template>
  <div>
    <div
      class="mb-3 flex w-full flex-col justify-between gap-4 lg:mb-10 lg:flex-row lg:items-baseline"
    >
      <Headline v-show="!isLoading" :is-uppercase="false"
        >{{ headline }}
      </Headline>

      <div
        v-if="hasFilters && isMobileOrTablet"
        class="flex w-full justify-between"
        :class="{ 'flex-col-reverse gap-2': isMobile }"
      >
        <div
          v-if="resultsCount && !isLoading"
          class="flex items-center gap-1 text-sm font-normal leading-none text-gray-secondary lg:font-bold"
        >
          <span>{{ resultsCount }}</span>
          <span>{{ $t('wishlist.products_count', resultsCount) }}</span>
        </div>

        <div class="flex w-full justify-end">
          <div
            class="order-1 flex items-center text-sm"
            :class="{
              'w-full flex-col gap-2 space-x-0': isMobile,
              'space-x-4': !isMobile,
            }"
          >
            <section class="hidden sm:flex">
              <OdoscopeSearchSortingMenu :values="values" />
            </section>
            <Button
              data-test-id="filter-toggle-button"
              type="tertiary"
              :is-full-width="isMobile"
              @click="toggleFilter"
            >
              <template #icon>
                <IconFilter class="size-5" />
              </template>
              <span class="sm:hidden">
                {{ $t('plp.filter_and_sort') }}
              </span>
              <span class="hidden sm:block">
                {{ $t('plp.filter') }}
              </span>
            </Button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isMobileOrTablet" class="flex max-w-full flex-col">
      <OdoscopeSearchActiveFilters
        v-if="activeFilters && filters"
        :filters="filters"
        :active-filters="activeFilters"
        @reset-price-filter="emit('resetPriceFilter')"
        @apply-attribute-filter="applyAttributeFilter"
        @reset-filter="emit('resetFilter', $event)"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import useSlideIn from '../../composables/useSlideIn'
import { useDeviceType } from '~/composables/useDeviceType'
import type { OdoscopeFilter } from '@goldner-group/storefront-odoscope/types'
import type { OdoscopeSortValue } from '../../utils/odoscopeSort'

interface Props {
  headline: string
  resultsCount: number
  hasFilters: boolean
  isLoading: boolean
  values: OdoscopeSortValue[]
  filters: OdoscopeFilter[]
}

interface Emits {
  (e: 'applyAttributeFilter', slug: string, values: string[]): void
  (e: 'resetFilter', slug: string): void
  (e: 'resetPriceFilter'): void
}

defineProps<Props>()

const emit = defineEmits<Emits>()

const { activeFilters } = usePlpQueryFilterState()
const { isMobile, isMobileOrTablet } = useDeviceType()
const { toggle: toggleFilter } = useSlideIn('OdoscopeFilterSlideIn')

const applyAttributeFilter = async (slug: string, values: string[]) => {
  emit('applyAttributeFilter', slug, values)
}
</script>
